export default __webpack_public_path__ + "static/media/social-media-1.9e987299.png";